
const state = {
  emailDrafts: undefined,
};
const getters = {
  getDrafts: state => state.emailDrafts
};
const actions = {
  addDraft({ commit }, draft) {
    commit('addDraft', draft);
  },
  removeDraft({ commit }, draft) {
    commit('removeDraft', draft);
  },
  fetchDrafts({ commit, state}) {
    if (state.emailDrafts == undefined) {
      const drafts = [];
      const keys = Object.keys(localStorage).filter((f) => {
        return f.includes('emailDraft-')
      });
      for (const k of keys) {
        drafts.push(parseInt(k.substr(11)));
      }
      commit('setDrafts', drafts);
    }
  },
  unloadDrafts({ commit, state}) {
    commit('setDrafts', []);
  },
};
const mutations = {
  setDrafts(state, drafts) {
    state.emailDrafts = drafts;
  },
  addDraft(state, draft) {
    state.emailDrafts.push(draft);
  },
  removeDraft(state, draft) {
    state.emailDrafts = state.emailDrafts.filter((d) => d != draft);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
